import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Button,
  CssBaseline,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  IconButton,
  TextField,
  Menu,
  MenuItem,
  Divider,Tooltip,
} from '@mui/material';
import {
  Close,
  Warehouse as WarehouseIcon,
  ExpandMore as ExpandMoreIcon,
} from '@mui/icons-material';
import { tokens } from '../../../theme/theme';
import { callApi } from '../../../utils/apiClient';
import { Warehouse_API_ENDPOINTS } from '../../../config/api/apiCallWarehouse';
import CallAlertBar from '../../../Layout/Alertbar';
import AddUpdateWarehouseType from './AddUpdateWarehouseType';
import { useNavigate } from 'react-router-dom';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import HelpIcon from '@mui/icons-material/HelpOutline';
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import { moduleHelpData } from '../../../data/moduleHelpData';
import ModuleHelpDialog from '../../../components/ModuleHelpDialog';

const WarehouseTypeIndex = ({ handleBackWinderMachineEntry }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const [warehouseList, setWarehouseList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [filters, setFilters] = useState({
    code: '',
    description: '',
    status: '',
  });

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [warehouseFormData, setWarehouseFormData] = useState({});

  // Alerts
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('info');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertTitle, setAlertTitle] = useState('');

  // 🔽 Menu state (All / Active / Inactive)
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState('All Warehouse Types');
  const open = Boolean(anchorEl);
const [helpOpen, setHelpOpen] = useState(false);
    const handleCloseHelp = () => setHelpOpen(false);
    const handleHelpMenuClick = () => setHelpOpen(true);


 const userPermissions = useUserPermissions();
  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleMenuItemClick = (option) => {
    setSelectedOption(option);
    handleMenuClose();
    setFilters({ code: '', description: '', status: '' }); // reset filters
  };

  // ✅ Load Data
  const LoadWarehouseList = () => {
    const payload = {
      p_company_id: localStorage.getItem('companyid'),
      p_plant_id: 1,
    };

    callApi(
      Warehouse_API_ENDPOINTS.warehouseType.list,
      'POST',
      { 'Content-Type': 'application/json' },
      payload
    )
      .then((data) => {
        if (data && data.length > 0) {
          setWarehouseList(data);
          setFilteredList(data);
        } else {
          setWarehouseList([]);
          setFilteredList([]);
          setAlertSeverity('warning');
          setAlertTitle('Warning');
          setAlertMessage('No warehouse type data found!');
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setWarehouseList([]);
        setFilteredList([]);
        setAlertSeverity('error');
        setAlertTitle('Error');
        setAlertMessage('Unable to load warehouse type details');
        setAlertOpen(true);
      });
  };

  useEffect(() => {
    LoadWarehouseList();
  }, []);

  // ✅ Filtering Logic
  useEffect(() => {
    // Step 1: Base list according to menu selection
    let baseList = warehouseList;

    if (selectedOption === 'Active Warehouse Types') {
      baseList = warehouseList.filter(
        (x) => x.status === true || x.status === 'Active'
      );
    } else if (selectedOption === 'Inactive Warehouse Types') {
      baseList = warehouseList.filter(
        (x) => x.status === false || x.status === 'Inactive'
      );
    }

    // Step 2: Apply column filters
    const filtered = (baseList || []).filter((row) => {
      const code = row.code?.toString().toLowerCase() || '';
      const description = row.description?.toString().toLowerCase() || '';

      // ✅ Normalize boolean status to text
      const statusText =
        row.status === true || row.status === 'Active'
          ? 'active'
          : 'inactive';

      // ✅ Get filters (normalize to lowercase)
      const filterCode = filters.code?.toLowerCase() || '';
      const filterDesc = filters.description?.toLowerCase() || '';
      const filterStatus = filters.status?.toLowerCase() || '';

      // ✅ Apply matching logic
      const matchCode = code.includes(filterCode);
      const matchDesc = description.includes(filterDesc);

      // ✅ Fix: status filter should match normalized text
      const matchStatus =
        filterStatus === ''
          ? true
          : statusText.startsWith(filterStatus);

      return matchCode && matchDesc && matchStatus;
    });

    setFilteredList(filtered);
  }, [filters, warehouseList, selectedOption]);


  // ✅ Handle filter input change
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAddWarehouse = () => {
    setWarehouseFormData({});
    setIsFormOpen(true);
  };

  const handleEditWarehouse = (wh) => {
    const payload = {
      p_company_id: localStorage.getItem('companyid'),
      p_plant_id: 1,
      p_id: wh.warehouse_type_id,
    };

    callApi(
      Warehouse_API_ENDPOINTS.warehouseType.getById,
      'POST',
      { 'Content-Type': 'application/json' },
      payload
    )
      .then((data) => {
        if (data && data.length > 0) {
          setWarehouseFormData(data[0]);
          setIsFormOpen(true);
        } else {
          setAlertSeverity('warning');
          setAlertTitle('Warning');
          setAlertMessage('No data found for selected Warehouse Type');
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setAlertSeverity('error');
        setAlertTitle('Error');
        setAlertMessage('Failed to fetch Warehouse Type details');
        setAlertOpen(true);
      });
  };

  const handleExit = () => {
    handleBackWinderMachineEntry();
  };

  const handleMenuClickSecond = (event) => {
        // setAnchorElSecond(event.currentTarget);
    };
     const handleMenuCloseSecond = () => {
        // setAnchorElSecond(null);
    };

    
    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        // handleMenuCloseSecond();
    };

  return (
    <Grid>
      {!isFormOpen && (
        <>
          <CssBaseline />
          <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}  >
            <Toolbar>
              <Box >
                <Button
                  color="secondary"
                  onClick={handleMenuClick}
                  endIcon={
                    <ExpandMoreIcon sx={{ color: 'teal', fontSize: '18px' }} />
                  }
                  sx={{ textTransform: 'none', fontSize: '16px', fontWeight: 500 }}
                >
                  {selectedOption}
                </Button>

                <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                  <MenuItem onClick={() => handleMenuItemClick('All Warehouse Types')}>
                    All Warehouse Types
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleMenuItemClick('Active Warehouse Types')}
                  >
                    Active Warehouse Types
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleMenuItemClick('Inactive Warehouse Types')}
                  >
                    Inactive Warehouse Types
                  </MenuItem>
                </Menu>
              </Box>
 {hasPermission(userPermissions, "Warehouse type", "Create") && (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<WarehouseIcon />}
                sx={{ ml: 'auto', textTransform: 'none' }}
                onClick={handleAddWarehouse}
              >
                New Warehouse Type
              </Button>
 )}
<Tooltip title="View help document details" arrow>
  <IconButton
    size="small"
    aria-label="help"
    sx={{ mx: 1 }}
    onClick={handleHelpMenuClick}
  >
    <HelpIcon sx={{ fontSize: 18 }} />
  </IconButton>
</Tooltip>


                        <ModuleHelpDialog
                            open={helpOpen}
                            onClose={handleCloseHelp}
                            data={moduleHelpData.WarehouseTypeMaster}
                        />

 
              <IconButton onClick={handleExit}>
                <Close style={{ fontSize: '16px', color: '#2196F3' }} />
              </IconButton>
            </Toolbar>
          </AppBar>

         


          <CallAlertBar
            parentRollMsgOpen={alertOpen}
            setParentRollMsgOpen={setAlertOpen}
            parentRollSeverityvalue={alertSeverity}
            setParentRollSeverityvalue={setAlertSeverity}
            parentRollAlertTitleValue={alertTitle}
            setParentRollAlertTitleValue={setAlertTitle}
            parentRollMessageValue={alertMessage}
            setParentRollMessageValue={setAlertMessage}
          />

          <Grid container padding={1} spacing={1}>
            <Grid item xs={12}>
              <Box
                sx={{
                  '& .MuiTableCell-root': {
                    border: '1px solid',
                    borderColor: `${colors.primary[400]} !important`,
                    padding: '4px',
                  },
                  maxHeight: '75vh',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': { width: '8px' },
                  '&::-webkit-scrollbar-thumb': {
                    background: colors.blueAccent[600],
                    borderRadius: '10px',
                  },
                }}
              >
                <TableContainer>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>WAREHOUSE TYPE CODE</TableCell>
                        <TableCell>WAREHOUSE TYPE DESCRIPTION</TableCell>
                        <TableCell>STATUS</TableCell>
                      </TableRow>

                      {/* 🔍 Column Filter Row */}
                      <TableRow>
                        {Object.keys(filters).map((key) => (
                          <TableCell key={key}>
                            <TextField
                              variant="outlined"
                              size="small"
                              placeholder="Search..."
                              fullWidth
                              value={filters[key]}
                              onChange={(e) =>
                                handleFilterChange(key, e.target.value)
                              }
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {filteredList.map((wh) => (
                        <TableRow key={wh.warehouse_type_id}>
                          <TableCell
                            sx={{
                              color: 'teal',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                            }}
                            onClick={() => handleEditWarehouse(wh)}
                          >
                            {wh.code}
                          </TableCell>
                          <TableCell>{wh.description}</TableCell>
                          <TableCell>
                            <Typography
                              sx={{
                                fontWeight: 600,
                              }}
                            >
                              {wh.status === true || wh.status === 'Active'
                                ? 'Active'
                                : 'Inactive'}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}

      {isFormOpen && (
        <AddUpdateWarehouseType
          warehouseFormData={warehouseFormData}
          setWarehouseFormData={setWarehouseFormData}
          setIsFormOpen={setIsFormOpen}
          LoadWarehouseList={LoadWarehouseList}
        />
      )}
    </Grid>
  );
};

export default WarehouseTypeIndex;
